<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page title="Premis">
      <div class="table_scrol">
         <div class="w-card__content content-hardcode mb3">
          <w-form v-model="valid" @validate="cari" ref="frm">
            <w-flex class="mt3">
              <z-select style="margin:5px;" :items="negeri" label="Negeri"  v-model="pencarian.lkp_negeri_id" @input="getDaerah(pencarian.lkp_negeri_id)" />
              <z-select style="margin:5px;" :items="daerah" class="mt4" label="Daerah"  v-model="pencarian.lkp_daerah_id" />
              <z-select style="margin:5px; " v-model="pencarian.lkp_jenis_pengguna_id" :items="jenis_pengguna" label="Kategori Premis" />
            </w-flex>
            <w-flex class="mt3">
              <w-input style="margin:5px; " v-model="pencarian.no_premis" label="ID Premis" />
              <w-input style="margin:5px; " v-model="pencarian.nama"  label="Nama Premis" />
              <z-select style="margin:5px; " v-model="pencarian.lkp_status_id" :items="lkp_status" label="Status" />
            </w-flex>
          </w-form>
          <w-flex justify-end class="mt2">
               <w-button class="mr2" v-on:click="resetPencarian()" v-on="on" bg-color="warning">
                    <w-icon class="mr1" md >fal fa-redo</w-icon>SET SEMULA
                </w-button>
               <w-button class="mr2" bg-color="primary" v-on="on" @click="$refs.frm.validate()">
                    <w-icon class="mr1" md >fal fa-search</w-icon>CARI
                </w-button>
          </w-flex>
        </div>
  		  <z-table title="Senarai Premis" :headers="table.headers" :items="table.items" :meta="table.meta" :mobile-breakpoint="700">
            <template #button v-if="$zutil.role('2') || $zutil.role('1') || $zutil.role('5')">
                <w-button dark class="green--bg ml1" v-on="on" :route="$route('daftar.premis.form',0)" >
                    <w-icon class="mr1" md >fal fa-plus</w-icon>TAMBAH
                </w-button>
                
         </template>
  		    <template #header-label="{ header, label, index }">
  		      <template v-if="header.key == 'action'">
  			      <!-- <w-icon xs>fal fa-pencil</w-icon> -->
              Tindakan
            </template>
  		      <template v-else>
  		      	{{ label }}
  		      </template>
  		    </template>
  		    <template #item-cell.action="{ item, label, header, index }">
  		      <w-flex class="flex justify-center">
               <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                       <inertia-link :href="$route('daftar.premis.show',item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 8px"></div> 
                        <w-icon md class="mr2">fal fa-eye</w-icon>
                     </inertia-link>
                </template>
               PAPAR
            </w-tooltip>
            &nbsp;
            <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                  <w-button class="fs-2" bg-color="red-light1" dark tile v-on="on" v-if="(item.ternakan == 0 )" @click="destroy1(item.id)"><div style="width: 8px"></div> 
                     <w-icon md class="mr2"> fal fa-trash</w-icon>
                  </w-button>
                </template>
               PADAM
            </w-tooltip>
  		      </w-flex>
  		    </template>
  		  </z-table>
      </div>
	  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'daftar.premis',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Daftar Premis & Ternakan', route: '/daftar' },
        { label: 'Premis', route: '/daftar/premis' },
      ],
      pencarian: {
         no_premis: '',
         nama: '',
         lkp_status_id: '',
         lkp_negeri_id: '',
         lkp_daerah_id: '',
         lkp_jenis_pengguna_id: '',
      },
      no_premis: [],
      nama: [],
      lkp_status :[],
      status_premis :[],
      negeri:[],
      daerah:[],
      // jenis_pengguna:[],
      jenis_pengguna:[
        {value: 1, label: "KERAJAAN"},
        {value: 2, label: "SWASTA"}
      ],
    }
  },
  methods: {

   cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       params.per_page =9999;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },

    getNegeri(){
        this.$zcomm.get(this.api_service + 'lookup/negeri/'+1, {}).then(res => {
          this.negeri = res

        })
      },

   getDaerah(i){
        this.$zcomm.get(this.api_service + 'lookup/daerah/'+i, {}).then(res => {
          this.daerah = res
        })
      },

    getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status_premis', {}).then(res => {
        this.lkp_status = res
      })
    },

    // getlkpJenisPengguna(){
    //     this.$zcomm.get(this.api_service + 'lookup/jenis_pengguna', {}).then(res => {
    //       this.jenis_pengguna = res
    //     })
    // },
      destroy1(id)
                {
                  this.$swal({
                    title: 'Anda Pasti?',
                    // text: "Are you sure want to delete this item!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya',
                    cancelButtonText: 'Tidak'
                  }).then((result) => {
                    if (result.value) {
                      this.$zcomm.delete(this.resourceurl + '.destroy',id)
                      .then(res => {
                        this.sending = false;
                        this.$inertia.visit(this.$page.url)
                        this.removeitem(res) // remove the data from list. no need to refresh page
                        if (typeof this.onAfterDelete === "function") {
                          this.onAfterDelete()
                        }
                      })
                      .finally(() => {
                        // $('#' + this.resourceurl).modal('hide')
                      });
                    }else{ }
                    })

                },

    
  
  },

  watch: {

  },
  mounted() {
   this.getStatus();
   this.getNegeri();
   // this.getlkpJenisPengguna();
   // this.getBandar();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
